import styled, { css } from 'styled-components';
import { spacing } from '@pb/styles';

/* DEFAULT STATES */
export const StyledContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => {
        return theme.color.grey1;
    }};
    padding: ${spacing(4, 0)};
    height: 6.6rem;
    max-width: 100%;
`;

export const StyledSteps = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.m.min}) {
        max-width: 62rem;
    }
`;

export const StyledStepContainer = styled.div<{ position?: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${spacing(2)};
    ${({ position }) =>
        position === 'Previous' &&
        css`
            cursor: pointer;
        `}
`;
/* PREVIOUS - SUCCESS STATES */
export const StyledSuccessIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: ${spacing(8)};
    width: ${spacing(8)};
    background-color: ${({ theme }) => theme.color.green};
`;
export const StyledSuccessStepName = styled.p`
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.green};
`;
/* PREVIOUS - ACTION NEEDED STATES */
export const StyledActionNeededIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: ${spacing(8)};
    width: ${spacing(8)};
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-size: 2.4rem;
    background-color: ${({ theme }) => theme.color.purple};
    color: ${({ theme }) => theme.color.white};
`;
export const StyledActionNeededStepName = styled.p`
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.purple};
`;
/* CURRENT STEP STATES */
export const StyledCurrentStepIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: ${spacing(8)};
    width: ${spacing(8)};
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    background-color: ${({ theme }) => theme.color.indigo};
    color: ${({ theme }) => theme.color.white};
`;
export const StyledCurrentStepName = styled.p`
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.indigo};
`;
/* FUTURE STEP STATES */
export const StyledFutureStepNumber = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.1rem solid ${({ theme }) => theme.color.grey6};
    border-radius: 50%;
    height: ${spacing(8)};
    width: ${spacing(8)};
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.grey6};
`;
export const StyledFutureStepName = styled.p`
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.grey6};
`;
